import React from 'react'
import PropTypes from 'prop-types'
import WizardRedux from 'common/pkgs/WizardRedux'

const DonatePage = (props) => {
    const {
        accessToken,
        refreshToken,
        submitActionType,
        submitPayload,
    } = props

    if (refreshToken && !accessToken) {
        return (
            <div>Using refresh token</div>
        )
    }
    return (
        <WizardRedux.Wrapper
            submitActionType={submitActionType}
            submitPayload={submitPayload}
            id="DonateWizard"
        >
            <WizardRedux.StepRoute
                url="/select-donation"
                as="/select-donation"
            />
            {!accessToken && (
                <WizardRedux.StepRoute
                    url="/login"
                    as="/login"
                />
            )}
            <WizardRedux.StepRoute
                method="replace"
                url="/cards"
                as="/cards"
            />
            <WizardRedux.StepRoute
                url="/confirm-payment"
                as="/confirm-payment"
            />
        </WizardRedux.Wrapper>
    )
}

DonatePage.propTypes = {
    accessToken: PropTypes.string.isRequired,
    refreshToken: PropTypes.string.isRequired,
    submitActionType: PropTypes.string.isRequired,
    submitPayload: PropTypes.object.isRequired,
}

export default DonatePage
